import { Breadcrumb, Card } from "antd";
import React from "react";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/quicktbreadrans.svg";
import AccountCard from "../../components/account-card";
import { ReactComponent as InternalIcon } from "../../assests/images/QuickTransfer.svg";
import { ReactComponent as OtherIcon } from "../../assests/images/beneTransfer.svg";
import { ReactComponent as LinkIcon } from "../../assests/images/link.svg";
import { ReactComponent as DeLinkIcon } from "../../assests/images/delink.svg";
import { ReactComponent as ManageBeneIcon } from "../../assests/images/manageBenfeciary.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function PesaLink() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.pesaLink", {
                defaultValue: "Pesalink",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.pesaLink", {
                defaultValue: "Pesalink",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard currencyFilter={true} />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card ">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/pesaLink/send-to-bank")}
                >
                  <div className="my-3">
                    <InternalIcon alt="new" height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.service_request.common_service.send_to_bank", {
                        defaultValue: "Send To Bank",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.service_request.common_service.make_transfer_txt",
                        {
                          defaultValue:
                            "Make transfer from one bank account to another",
                        }
                      )}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/pesaLink/send-to-phone")}
                >
                  <div className="my-3">
                    <OtherIcon alt="new" height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.service_request.common_service.send_to_phone", {
                        defaultValue: "Send To Phone",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.service_request.common_service.mobile_direct_txt",
                        {
                          defaultValue:
                            "Send money directly to the bank account using mobile number",
                        }
                      )}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/pesaLink/link-account")}
                >
                  <div className="my-3">
                    <LinkIcon alt="new" height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t(
                        "pages.service_request.common_service.link_your_phone",
                        {
                          defaultValue: "Link Your Phone",
                        }
                      )}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.service_request.common_service.link_your_phone_to_pesa_link",
                        {
                          defaultValue: "Link your phone to Pesalink",
                        }
                      )}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() => navigate("/pesaLink/delink-account")}
                >
                  <div className="my-3">
                    <DeLinkIcon alt="new" height={40} />
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t(
                        "pages.service_request.common_service.dlink_your_phone",
                        {
                          defaultValue: "De-Link Your Phone",
                        }
                      )}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t(
                        "pages.service_request.common_service.remove_your_phone_to_pesa_link",
                        {
                          defaultValue: "Remove your phone from Pesalink",
                        }
                      )}
                    </span>
                  </div>
                </Card>
              </div>
           
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/pesaLink/manage-beneficiary")}
                  >
                    <div className="my-3">
                      <ManageBeneIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("pages.Add_Bene.manage_beneficiaries", {
                          defaultValue: "Manage Beneficiaries",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        Manage Your Beneficiaries
                      </span>
                    </div>
                  </Card>
                </div>
            
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
